import React from "react";
import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../common/Table/table";
import { Modal } from "react-bootstrap";
import AddUpdateSupplier from "./addUpdateSupplier";
import {
  getSupplierSlice,
  getSupplierByIdSlice,
  addSupplierSlice,
  updateSupplierSlice,
  deleteSupplierSlice,
  resetAddSupplierMessage,
  resetUpdateSupplierMessage,
  resetDeleteSupplierMessage,
} from "../../../store/slices/supplierSlice";
import { getGstinTypeSlice } from "../../../store/slices/gstinTypeSlice";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import ViewModal from "../../common/viewModal/globalViewModal";

const Supplier = () => {
  const dispatch = useDispatch();
  const [showModal, setModalVisible] = useState(false);
  const [showDeleteModal, setDeleteModalVisible] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [deleteSupplier, setDeleteSupplier] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [pageLimit, setPageLimit] = useState(10);
  const tableHead = [
    { title: "Supplier Name", key: "name" },
    { title: "Mobile No.", key: "contact" },
    { title: "GSTIN", key: "gstin" },
    { title: "Status", key: "status" },
  ];

  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    gstin: "",
    address: "",
    status: "Active ",
    gstinType: "",
    gstinTypeName: "",
    email: "",
  });
  const [inputError, setInputError] = useState({
    name: false,
  });

  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const {
    supplier,
    supplierById,
    addSupplierSuccessMessage,
    addSupplierErrorMessage,
    updateSupplierSuccessMessage,
    updateSupplierErrorMessage,
    deleteSupplierSuccessMessage,
    deleteSupplierErrorMessage,
    searchSupplierErrorMessage,
    currentPage,
    totalPages,
    totalCount,
    isLoading,
  } = useSelector((state) => state.supplier);
  const { gstinTypes } = useSelector((state) => state.gstinType);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const { tableStatus } = useSelector((state) => state.tableStatusChange);
  useEffect(() => {
    showTostifyMessageAndReset(
      addSupplierSuccessMessage,
      showToastifySuccess,
      resetAddSupplierMessage,
    );
    showTostifyMessageAndReset(
      addSupplierErrorMessage,
      showToastifyError,
      resetAddSupplierMessage,
    );
    showTostifyMessageAndReset(
      updateSupplierSuccessMessage,
      showToastifySuccess,
      resetUpdateSupplierMessage,
    );
    showTostifyMessageAndReset(
      updateSupplierErrorMessage,
      showToastifyError,
      resetUpdateSupplierMessage,
    );
    showTostifyMessageAndReset(
      deleteSupplierSuccessMessage,
      showToastifySuccess,
      resetDeleteSupplierMessage,
    );
    showTostifyMessageAndReset(
      deleteSupplierErrorMessage,
      showToastifyError,
      resetDeleteSupplierMessage,
    );
  }, [
    addSupplierSuccessMessage,
    addSupplierErrorMessage,
    updateSupplierSuccessMessage,
    updateSupplierErrorMessage,
    deleteSupplierSuccessMessage,
    deleteSupplierErrorMessage,
    showTostifyMessageAndReset,
  ]);
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  useEffect(() => {
    dispatch(getGstinTypeSlice({ status: ["Active"], token }));
  }, [dispatch, token, showModal]);

  const fetchSupplier = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getSupplierSlice({
            clinicId,
            status: tableStatus,
            token,
            currentPage: page,
            limit: lim,
            name: search || undefined,
          }),
        );
      }
    },
    [clinicId, token, dispatch, tableStatus,pageLimit, searchValue],
  );

  useEffect(() => {
    fetchSupplier();
  }, [fetchSupplier, showModal, showDeleteModal, showGlobalViewModal,]);
  const handlePageChange = (page) => {
    fetchSupplier(page, pageLimit, searchValue);
  };
  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchSupplier(1, newLimit, searchValue);
  };
  const handleChange = (e, field = null) => {
    if (field === "gstinType") {
      setFormData((prev) => ({
        ...prev,
        gstinType: e?.value || "",
        gstinTypeName: e?.label || "",
      }));
    } else if (e?.target) {
      const { name, value } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else if (e?.editor) {
      const value = e.editor.getData();
      setFormData((prev) => ({
        ...prev,
        address: value,
      }));
    }
  };

  const stripHtmlTags = (html) => {
    if (!html) return "";
    return html.replace(/<[^>]*>/g, "");
  };
  const handleModal = (action, supplier = null) => {
    if (action === "create") {
      setFormData({
        name: "",
        contact: "",
        gstin: "",
        address: "",
        status: "Active",
        gstinType: "",
        gstinTypeName: "",
        email: "",
      });
    } else if (action === "edit" && supplier) {
      setFormData({
        id: supplier?.id,
        name: supplier?.name,
        email: supplier?.email,
        contact: supplier?.contact,
        gstin: supplier?.gstin,
        address: stripHtmlTags(supplier?.address),
        gstinType: supplier?.gstinType?._id,
        gstinTypeName: supplier?.gstinType?.name,
        status: supplier?.status,
      });
    }
    setModalVisible(true);
    setModalAction(action);
  };

  const handleEdit = async (supplier) => {
    try {
      const response = await dispatch(
        getSupplierByIdSlice({ id: supplier?.id, token }),
      );
      if (response?.payload) {
        const supplierData = response?.payload?.result?.list;
        handleModal("edit", supplierData);
        setFormData({
          id: supplierData?._id,
          name: supplierData?.name,
          email: supplierData?.email,
          contact: supplierData?.contact,
          gstin: supplierData?.gstin,
          address: stripHtmlTags(supplierData?.address),
          gstinType: supplierData?.gstinType?._id,
          gstinTypeName: supplierData?.gstinType?.name,
          status: supplierData?.status,
        });
      }
    } catch (error) {
      console.error("Failed to get Supplier. Please Try Later..", error);
    }
  };
  const handleAddOrUpdateSupplier = async (e) => {
    e.preventDefault();
    try {
      const { name } = inputError;
      if (name) {
        return;
      }
      if (modalAction === "create") {
        await dispatch(
          addSupplierSlice({
            ...formData,
            clinicId,
            token,
          }),
        );
      } else {
        await dispatch(
          updateSupplierSlice({
            ...formData,
            clinicId,
            token,
          }),
        );

        fetchSupplier();
      }

      setModalVisible(false);
      setFormData({
        id: "",
        name: "",
        contact: "",
        gstin: "",
        address: "",
        status: "Active",
        gstinType: "",
        gstinTypeName: "",
        email: "",
      });
    } catch (error) {
      console.error("Error occurred while handling Supplier operation:", error);
    }
  };

  const handleUpdateStatus = async (status, item) => {
    try {
      const response = await dispatch(
        getSupplierByIdSlice({ id: item?.id, token }),
      );
      const supplierData = response?.payload?.result?.list;
      const updateData = {
        id: supplierData?._id,
        name: supplierData?.name,
        email: supplierData?.email,
        contact: supplierData?.contact,
        gstin: supplierData?.gstin,
        address: stripHtmlTags(supplierData?.address),
        gstinType: supplierData?.gstinType?._id,
        gstinTypeName: supplierData?.gstinType?.name,
        status: status,
        clinicId,
        token,
      };

      await dispatch(updateSupplierSlice(updateData));
      if (clinicId) {
        fetchSupplier(currentPage, pageLimit, searchValue);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSearch = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchValue(value);
      fetchSupplier(1, pageLimit, value);
    },
    [fetchSupplier, pageLimit],
  );

  const handleShowGlobalViewModal = async (data) => {
    await dispatch(
      getSupplierByIdSlice({
        id: data?.id,
        clinicId,
        token,
      }),
    );
    setShowGlobalViewModal(true);
  };

  const handleDeleteSupplier = async () => {
    try {
      await dispatch(
        deleteSupplierSlice({
          id: deleteSupplier,
          clinicId,
          token,
        }),
      );
      setDeleteModalVisible(false);
      fetchSupplier();
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  const handleDelete = (Id) => {
    setDeleteSupplier(Id.id);
    setDeleteModalVisible(true);
  };
  return (
    <div className="container mt-4">
      <Table
        tableHead={tableHead}
        tableBody={
          supplier &&
          supplier.map((item) => ({
            id: item?._id,
            name: item?.name || "N/A",
            contact: item?.contact || "N/A",
            gstin: item?.gstin || "N/A",
            status: item?.status || "N/A",
          }))
        }
        handleAddBtn={true}
        handleSearchOption={true}
        searchValue={searchValue}
        handleSearch={handleSearch}
        handleDelete={handleDelete}
        handleDeleteSupplier={handleDeleteSupplier}
        errorMessage={searchSupplierErrorMessage}
        handleEdit={handleEdit}
        addModal={() => handleModal("create")}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        showStatus={showStatus}
        setShowStatus={setShowStatus}
        handleUpdateStatus={handleUpdateStatus}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={isLoading}
      />
      <AddUpdateSupplier
        handleChange={handleChange}
        setModalVisible={setModalVisible}
        showModal={showModal}
        modalAction={modalAction}
        handleAddOrUpdateSupplier={handleAddOrUpdateSupplier}
        formData={formData}
        handleEdit={handleEdit}
        gstinTypes={gstinTypes}
        setInputError={setInputError}
        inputError={inputError}
      />
      <Modal
        centered
        show={showDeleteModal}
        onHide={() => setDeleteModalVisible(false)}
        size="md"
      >
        <div className="modal-header">
          <h5 className="modal-title">Delete AccountType</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to delete this Bank?</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModalVisible(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDeleteSupplier}
          >
            Delete
          </button>
        </div>
      </Modal>
      <ViewModal
        showGlobalViewModal={showGlobalViewModal}
        setShowGlobalViewModal={setShowGlobalViewModal}
        modalSize={"lg"}
        titel={tableHead}
        content={{
          id: supplierById?._id,
          name: supplierById?.name,
          contact: supplierById?.contact,
          gstin: supplierById?.gstin,
          accountType: supplierById?.accountType?.name,
          status: supplierById?.status,
        }}
      />
    </div>
  );
};

export default Supplier;
